import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@dixa/lib-shared-habla';
import { useCallback, useMemo } from 'react';
import { useScheduleContext } from 'components/settings/components/sections/openingHours/views/schedule/schedule.context';
export function AnnouncementSelect({ placeholder = 'No audio selected', selectedAudio, onSelect, }) {
    const { announcements } = useScheduleContext();
    const isLoading = !announcements;
    const items = useMemo(() => (announcements === null || announcements === void 0 ? void 0 : announcements.map(({ url, label }) => ({
        id: url,
        name: label,
    }))) || [], [announcements]);
    const handleItemSelect = useCallback((item) => {
        const selectedItem = announcements === null || announcements === void 0 ? void 0 : announcements.find(({ url }) => url === (item === null || item === void 0 ? void 0 : item.id));
        if (selectedItem) {
            onSelect(selectedItem);
        }
    }, [announcements, onSelect]);
    return (_jsx(Select, { placeholder: isLoading ? 'Loading...' : placeholder, items: items, dropdownProps: { fixed: true }, selectedItems: selectedAudio
            ? [{ id: selectedAudio.url, name: selectedAudio.label }]
            : [], onSelect: handleItemSelect, disabled: isLoading, searchable: true }));
}
